export const TASK_HQ_PAGE_DATAGRID_STATE_STORAGE_KEYS = {
    TASK_IN_FLIGHT_TAB: "task-hq-page-in-flight-tasks-tab-datagrid-storage-key_v1",
    TASK_PAST_DUE_TAB: "task-hq-page-past-due-tasks-tab-datagrid-storage-key_v1",
};
export const USER_TYPE={
    NORMAL:"NORMAL",
    EG:"EG",
    TG:"TG"
}